<template>
<!--  -->
  <div class='policy-release'>
    <div style="margin-bottom: 20px">
      <CarouselPage></CarouselPage>
    </div>
    <div style='padding: 0 8%'>
      <div class='search-action'>
        <div class="title"><Icon type="md-search" style="font-size: 20px" />筛选条件</div>
        <div class="content">
          <div class='form'>
            <Form :model="searchParam" inline :label-width="120" label-position="right">
                <Row>
                  <!-- <Col :xs="12" :sm="12" :md="12" :lg="12">
                      <FormItem label="诚信行为性质：" style="width: 100%">
                        <div class='cover-b-l-t-l'>
                          <p
                            v-for='item in creditInfoTypeList'
                            :key='"b-l-t-l-" + item.dicCode'
                            @click='searchParam.creditStatus = item.dicCode'
                            :class='{"b-l-t-l": true, action: searchParam.creditStatus === item.dicCode}'
                            >{{item.dicName}}</p>
                        </div>
                      </FormItem>
                  </Col> -->
                  <Col :xs="8" :sm="8" :md="8" :lg="8">
                      <FormItem label="市场主体：" style="width: 100%">
                          <Select v-model="searchParam.dicBazaarId" clearable>
                              <Option v-for="item in corpType" :value="item.dicCode" :key="item.dicCode">{{ item.dicName }}</Option>
                          </Select>
                      </FormItem>
                  </Col>
                  <Col :xs="8" :sm="8" :md="8" :lg="8">
                        <FormItem label="企业名称：" style="width: 100%">
                          <Input v-model="searchParam.corpName" clearable search placeholder="请输入"></Input>
                      </FormItem>
                  </Col>
                  <Col :xs="8" :sm="8" :md="8" :lg="8">
                      <FormItem label="最低得分：" style="width: 100%">
                          <Input v-model="searchParam.lowScore" clearable search placeholder="请输入"></Input>
                      </FormItem>
                  </Col>
                  <Col :xs="8" :sm="8" :md="8" :lg="8">
                      <FormItem label="最高得分：" style="width: 100%">
                          <Input v-model="searchParam.highScore" clearable search placeholder="请输入"></Input>
                      </FormItem>
                  </Col>
                  <Col :xs="8" offset="8" :sm="8" :md="8" :lg="8">
                    <Button style="width: 100px;float:right;margin-left:20px;" @click="handleInitParam">重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置</Button>
                    <Button type="primary" @click='handleSearch' style="width: 100px;float:right;">开始查询</Button>

                  </Col>
                </Row>
            </Form>
          </div>
          <!-- <div class='action'>
              <Button type="primary" @click='handleSearch' style="width: 100px; margin-bottom: 10px">开始查询</Button>
              <Button style="width: 100px;" @click="handleInitParam">重&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;置</Button>
          </div> -->
        </div>
      </div>
      <div class="cover-table">
        <Table :columns="columns" border :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="action">
                <div class="table-btn" style="cursor:pointer;" @click="handleDeal('creditScoreDetail',row, true)">{{row.corpName}}</div>
            </template>
          </Table>
          <div class="t-page">
              <Page class-name='pageBorder' :total="totalCount" :page-size="searchParam.pageSize" :current="searchParam.page"
                    @on-change="changePage" @on-page-size-change="pageSizeChange"
                    show-elevator show-sizer show-total transfer>
              </Page>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tableMixin from '@/components/tableMixin';
import { getCreditGradeList } from '@/api/homePage.js'
import CarouselPage from './carouselPage.vue'

export default {
  name: '',
  props: {

  },
  data () {
    return {
        carousel: 0,
        imgList: [],
        totalCount:10,
        corpType:[
            {dicName:'建设单位',dicCode:'13'}
        ],
        searchParam: {
            dicBazaarId:'',
            corpName:'',
            lowScore:'',
            highScore:'',
            page:1,
            pageSize:10
        },
        columns: [
            {
                title: '序号',
                type: 'index',
                width: 70,
                align: 'center',
                 className: 'cell-hmd'
            },
            {
                title: '企业名称',
                key: 'corpName',
                minWidth: 200,
                align: 'center',
                slot:'action'
            },
            {
                title: '企业类型',
                key: 'corptName',
                align: 'center',
                minWidth: 100,
                className: 'cell-hmd'
            },
            {
                title: '良好信用加分',
                key: 'goodScoreChange',
                align: 'center',
                width: 150,
                className: 'cell-hmd'
            },
            {
                title: '不良信用减分',
                key: 'badScoreChange',
                align: 'center',
                width: 150,
                className: 'cell-hmd'
            },
            {
                title: '当日信用分值',
                key: 'creditScore',
                align: 'center',
                width: 150,
                className: 'cell-hmd'
            },
            {
                title: '季度信用分值',
                key: 'quarterCreditScore',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            },
            {
                title: '更新时间',
                key: 'updateDate',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            },
            {
                title: '计算时间',
                key: 'goodCreateDate',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            }
        ],
        tableData: []
    }
  },
  mixins: [tableMixin],
  components: {
    CarouselPage
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    handleSearch() {
      this.getTableData()
    },
    handleInitParam() {
        this.searchParam = {
            dicBazaarId:'',
            corpName:'',
            lowScore:'',
            highScore:'',
            page:1,
            pageSize:10
        }
    },
    pageSizeChange(value){
        this.searchParam.pageSize = value
        this.getTableData()
    },
    changePage(value) {
        this.searchParam.page = value
        this.getTableData()
    },
    // 获取表格数据
    getTableData() {
      getCreditGradeList(this.searchParam).then((res) => {
        // console.log(res)
        if (!res) return this.$Message.error('获取列表信息失败')
        this.totalCount = res.data.totalCount
        this.tableData = res.data.data
        // console.log(this.$store.state._dict.market_type)
        for(let i in this.tableData) {
            for(let j in this.$store.state._dict.market_type) {
                if(this.tableData[i].dicBazaarId == this.$store.state._dict.market_type[j].dicCode) {
                    this.tableData[i].corptName = this.$store.state._dict.market_type[j].dicName
                }
            }
        }
      }).catch(() => {
        this.$Message.error('获取列表信息失败')
      })
    },
    /*处理操作*/
    handleDeal(name, row){
        this.$router.push({
            name: name,
            query: {
                row
            }
        });
    },
    handleTypeChange(val) {

    }
  }
}
</script>

<style lang="less" scoped>
  .policy-release {
    background: #f5f5f5;
    height: 100%;
    padding: 0 0px 20px;
    .cover-table {
      background: #fff;
      border-radius: 4px;
      padding: 15px 15px 0;
    }
  }
</style>
<style lang="less">
    .cover-table {
        .cell-hmd {
        padding: 0px;
        color: #808080;
        }
        .color-black08 {
        color: #808080;
        }
  }
  .search-action {
    background: #fff;
    margin: 15px 0;
    &>.title {
      // height: 30px;
      font-size: 18px;
      padding: 8px 12px;
      line-height: 22px;
      border-bottom: 2px solid #EFEFEF;
    }
    &>.content {
      padding: 15px 15px 0;
      display: flex;
      flex-direction: row;
      &>.form {
        flex: 1;
        padding: 0 2px;
        .cover-b-l-t-l {
          height: 34px;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .b-l-t-l {
            width: 33%;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #0180DD;
            border-radius: 3px;
            cursor: pointer;
          }
          .b-l-t-l.action {
            color: #fff;
            background: #0180DD;
          }
        }

      }
      &>.action {
        width: 170px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
    .pageBorder {
        .ivu-page-item {
            border-radius: 100%;
        }
        .ivu-page-prev {
            border-radius: 100%;
        }
        .ivu-page-next {
            border-radius: 100%;
        }
        .ivu-page-next {
            border-radius: 30px;
        }
        .ivu-page-options-elevator input {
            border-radius: 30px;
        }
    }
</style>
<style lang="less">
  .tables {
    /deep/.ivu-tabs-nav-scroll {
      background: #fff;
    }
  }
</style>
